import React from "react"
import PropTypes from "prop-types"
import {
  Button,
  Col,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
  Form
} from "reactstrap"
import { Formik, Field, Form as FormikForm, ErrorMessage } from "formik"
import * as Yup from "yup";
import { CLIENT_SYNC_TYPE } from "services/intzEnum";

const ParameterEntryModal = props => {
    const { show, entityData, isEdit, onClose, errorMessage, appActionId } = props;

    return (
    <Modal isOpen={show}>
        <ModalHeader tag="h4">
            {!!isEdit ? "Edit Parameter" : "Add new Parameter"}
        </ModalHeader>
        <ModalBody>
        <Formik
            enableReinitialize
            initialValues={entityData || {
                id: '',
                key: '',
                value: '',
                syncType : CLIENT_SYNC_TYPE.CREATED
            }}
            validationSchema={Yup.object({
                key: Yup.string().required("Please enter key"),
                value: Yup.string().required("Please enter value")
            })}
            onSubmit={(values, { resetForm }) => {
                onClose({appActionId : appActionId, syncType : isEdit ? CLIENT_SYNC_TYPE.UPDATED : CLIENT_SYNC_TYPE.CREATED,  ...values});
                resetForm();
                
            }}
        >
            {({ errors, touched,values,setFieldValue }) => (
            <FormikForm>
                <Row>
                    <Col className="col-12">
                        {isEdit  && <div className="mb-3">
                        <Label className="form-label">#</Label>
                        <Field name="id" as={Input} readOnly invalid={touched.id && errors.id ? true : false} />
                        <ErrorMessage name="id" component={FormFeedback} />
                        </div>}
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="mb-3">
                            <Label className="form-label">Key</Label>
                            <Field name="key" as={Input} placeholder="Key" invalid={touched.key && errors.key ? true : false} />
                            <ErrorMessage name="key" component={FormFeedback} />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col md="9">
                        <div className="mb-3">
                            <Label className="form-label">Value</Label>
                            <Field name="value" as={Input} placeholder="Value" invalid={touched.value && errors.value ? true : false} />
                            <ErrorMessage name="value" component={FormFeedback} />
                        </div>
                    </Col>
                
                </Row>
                
                <Row>
                    <Col>
                        <div className="text-end">
                            <button type="button" className="btn btn-secondary" onClick={() => onClose()}>Cancel</button>
                            &nbsp;&nbsp;
                            <button type="submit" className="btn btn-success save-integration">Save</button>
                        </div>
                    </Col>
                </Row>
            </FormikForm>
            )}
        </Formik>
        </ModalBody>
    </Modal>
    )
}

export default ParameterEntryModal;
